import React, { useState,useEffect,useContext } from "react";
import { toast } from "react-toastify";
import Select from "react-select";
import OtpInput from 'react-otp-input';
import { Checkbox } from "antd";
import { BsPhone } from "react-icons/bs";
import { IoMdPhonePortrait } from "react-icons/io";
import Wififlow from "../Subscription/Wififlow";
import { postRequest } from "../../lib/lib";
import { LanguageContext } from "../../components/LanguageContext"
import Loader from "../Loader";
import { useTranslation } from "react-i18next";
import {customStyles,PrimaryButton,CancelButton,ConfirmButton,HomeContainer,ContentContainer,InfoBox,SubInfo} from "../../utils/style";
import {serviceId,countryCode,languages,flag} from "../../utils/constant";
import '../Css/style.css';
import TermsModal from "../../components/TermsModal";

const Sub = () => {
  const [alias, setAlias] = useState(localStorage.getItem("kmAlias"));
  const [loader, setLoader] = useState(false);
  const [flow, setFlow] = useState("");
  const [plan, setPlan] = useState(1);
  const [price, setPrice] = useState([0,60,300,70,350]);
  const [planType, setPlanType] = useState(["0","Day","Week","DayOneTime","WeekOneTime"]); 
  const [alreadySub, setAlreadySub] = useState(false);
  const [subOption, setSubOption] = useState(1);  
  const [uiState, setUistate] = useState({message: "", hide_browse: false,sub: false});
  const [number, setNumber] = useState("");
  const [uniqueId, setUniqueId] = useState('');   
  const [subMode, setSubMode] = useState('WAP');
  const [otpId, setOtpId] = useState('');
  const [otp, setOtp] = useState('');
  const { t } = useTranslation("global"); 
  const [termsModal,setTermsModal]=useState(false);
  

  useEffect(() => {
    console.log("Number="+alias);
     if (alias) {
            async function checkStatus()
            { 
              setLoader(true);
              const [e1, data] = await postRequest("ocmKm",{action:0,ani: number,serviceId:serviceId,alias:alias});    
              setLoader(false);            
              if(e1==null && data !=null) 
              {
                localStorage.setItem("token", data.data.accessToken);
                setAlreadySub(true); setFlow("SUCCESS");
              }
              else
              {
                setFlow("HE");
                console.log(e1.response.data);
                //if(e1.response.data)return toast.info(e1.response.data.message);
              }              
            }
            checkStatus();
          }           
      }, []);  

     const sendOtp = async() => {
          console.log('number='+number);
          if(number.length>=8)
          {
              var nm=number;if(nm.length<=10)nm=countryCode+nm
              setLoader(true);
              const [e1, data] = await postRequest("ocmKm",{action:3,serviceId:serviceId,ani:nm,mode:subMode,uid:uniqueId});    
              setLoader(false);            
              if(e1==null && data !=null) 
              {
                if(data.responseCode===202)
                {
                  localStorage.setItem("token", data.data.accessToken);
                  setAlreadySub(true); setFlow("SUCCESS");
                }
                else if(data.responseCode===201) // already exist he 
                {                        
                    localStorage.setItem("ugAlias", data.data);
                    setAlias(data.data)
                    setFlow("HE");
                }
                else
                {
                    setOtpId(data.data);
                    setFlow("ENTEROTP");                      
                }
              }
              else
              {
                console.log(e1.response.data);
                if(e1.response.data)return toast.info(e1.response.data.message);
              }
          }else {return toast.info("Enter a valid number");}
        };
  
    const confirmOtp = async() => {  
          if(otp!=null && otp.length===4)
          {
            var nm=number;if(nm.length<=8)nm=countryCode+nm
            setLoader(true);
            const [e1, data] = await postRequest("ocmKm",{action:4,serviceId:serviceId,ani: nm,otpId:otpId,otp:otp,mode:subMode,uid:uniqueId});    
            setLoader(false);            
            if(e1==null && data !=null) 
            {
              if(data.responseCode===202)
              {
                localStorage.setItem("token", data.data.accessToken);
                setAlreadySub(true); setFlow("SUCCESS");
              }
              else 
              {                        
                  localStorage.setItem("ugAlias", data.data);
                  setAlias(data.data)
                  setFlow("HE");
              }
            }
            else{
              console.log(e1.response.data);
              if(e1.response.data)return toast.info(e1.response.data.message);
            }           
          }else {return toast.info("Enter four digit OTP");}
    }
    const subscribe = async() => {     
      if(alias && alias.length>5)
      {
        setLoader(true);
        const [e1, data] = await postRequest("ocmKm",{action:1,serviceId:serviceId,planId:plan,ani:number,mode:subMode,uid:uniqueId,alias:alias});    
        setLoader(false); 
          if(e1==null && data !=null) 
          {
            localStorage.setItem("token",data.data.accessToken);
            setFlow("SUCCESS");
          }
          else {return toast.info(e1.message);}        
         
      }
      else setFlow(" ");
    }
    const handleNumberChange = async(event) =>{
        const input = event.target.value;
        if(input.length<11)setNumber(input);
    }  
      const checkBoxHandle = (e) => {
    const { name } = e.target;
    setPlan(name);
  };

  const subOptionCheckBox = (e) => {
    const { name } = e.target;
    setSubOption(name);
    if(name===1)setPlan(1);
    else setPlan(3);
  };
  const handleNumInputsChange = (numInputs) => {
        setOtp(numInputs);
      };

  const redirectTo = async() => {
    window.location.href ="/home";
   }

     // Language option //      
      const { language, changeLanguage } = useContext(LanguageContext);            
      const selectedOption = languages.find((option) => option.value === language);
      const handleChange = (selectedOption) => {changeLanguage(selectedOption.value)}

  return (
    <React.Fragment>
      <HomeContainer>
        <ContentContainer>
          <InfoBox>        
           <SubInfo>
                <div className='pt-5'>
                  <div className="row align-items-center">
                      <div className="col-4"></div>
                      <div className="col-4">
                        
                      </div>
                      <div className="col-4">
                            <img src="/images/logo.png" alt="Kidz Mania" className="img"/>  
                      </div>  
                  </div>
                </div>                 
                {flow === "HE" ? (<>
                  <h2>{t("portalText.subOpt")}</h2>
                  <>
                    <Checkbox
                      className="checkbox"
                      checked={subOption === 2 ? false : true}
                      style={{transform: "scale(1.5)",}}
                      name={1}
                      onChange={subOptionCheckBox}
                    >{t("portalText.Subscribe")}</Checkbox>  
                    <Checkbox
                      className="checkbox"
                      style={{transform: "scale(1.5)",}}
                      checked={subOption === 2 ? true : false}
                      name={2}
                      onChange={subOptionCheckBox}
                    > {t("portalText.One Time")}</Checkbox>
                    {subOption === 2 ?
                    <>{t("portalText.popupMsgOne")}</>
                     :<>{t("portalText.popupMsg")}</>
                    }
                    <PrimaryButton disabled={loader}  name="subscribe" onClick={()=>setFlow("PACK")} type="primary">
                    {t("portalText.Submit")} </PrimaryButton>
                  </>
                </>
              ):flow === "ENTEROTP" ?( <>
                <h2>{t("portalText.receivedOTP")}</h2>
                <h2>{t("portalText.Enter OTP")}</h2>
                <div className="login-info">
                <div className="phone-info">
                      <div className="otp_section">               
                          <OtpInput
                              value={otp}
                              numInputs={4}
                              renderInput={(props, index) => (
                                  <input   {...props}  type="tel" inputMode="numeric" />
                              )}
                              inputStyle="form-control form-otp"
                              onChange={handleNumInputsChange}
                          />
                      </div>
                  </div>
                </div>
                <PrimaryButton disabled={loader}  name="confirmOtp" onClick={confirmOtp} type="primary">
                  {t("portalText.Submit")}
                </PrimaryButton>
    
              </>
              ):flow === "SUCCESS" ? (<>
                  {subOption===2?(
                    <>
                        {alreadySub?
                          <h2 className="mt-3 text-center">{t("portalText.AlreadySubOneTime")}</h2>
                          : <h2 className="mb-3 mt-3 text-center">{t("portalText.SubSuccessOneTime")+ "("+price[plan]+"U/"+t("portalText."+planType[plan])+")"}</h2>
                        }
                    </>):(<>
                        {alreadySub?
                        <h2 className="mb-3 mt-3 text-center">{t("portalText.AlreadySub")}</h2>
                        : <h2 className="mb-3 mt-3 text-center">{t("portalText.SubSuccess")+ "("+price[plan]+"U/"+t("portalText."+planType[plan])+")"}</h2>
                        }
                    </>)}   
                                                
                    <p className="mb-3 mt-3 text-center">{t("portalText.Access Service")}</p>
                    <PrimaryButton disabled={loader} name="success" onClick={redirectTo} type="primary"
                    >{t("portalText.clickHere")}</PrimaryButton> 
              </>
              ):flow === "CONFIRM" ? (<>
                  {subOption === 2?<>
                      {t("portalText.confirmOne")}
                      {plan===4?t("portalText.WeekOneTime"):t("portalText.DayOneTime")}
                      {" "+price[plan]+"U "}
                      
                      {t("portalText.confirmOne1")}
                    </>                          
                    :<>
                      {t("portalText.confirmSub")}                           
                        {price[plan]+"U/"}
                        {plan===2?t("portalText.Week"):t("portalText.Day")+" "}                           
                      {t("portalText.confirmSub1")}
                    </>}
                      <ConfirmButton disabled={loader} name="confirm" onClick={subscribe} type="primary"
                      > {t("portalText.Confirm")}
                      </ConfirmButton>                
                      <CancelButton disabled={loader} name="cancel" onClick={()=>setFlow("HE")}type="primary"
                      > {t("portalText.Cancel")}
                      </CancelButton>                             
                  </>
                ):flow === "PACK" ? (<>
                  {subOption === 2?
                      <>
                      <h2>{t("portalText.One Time Plan")}</h2>
                        {/* SELECTION */}
                        <div className="pack-select">
                          <Checkbox
                            className="checkbox"
                            checked={plan === 4 ? false : true}
                            style={{transform: "scale(1.5)",}}
                            name={3}
                            onChange={checkBoxHandle}
                          > {t("portalText.DayOneTime")}</Checkbox>

                          <Checkbox
                            className="checkbox"
                            style={{transform: "scale(1.5)",}}
                            checked={plan === 4 ? true : false}
                            name={4}
                            onChange={checkBoxHandle}
                          > 350U/{t("portalText.WeekOneTime")}</Checkbox>
                        </div>
                      </>
                  :
                    <>
                    <h2>{t("portalText.Sub Plan")}</h2>
                      {/* SELECTION */}
                      <div className="pack-select">
                        <Checkbox
                          className="checkbox"
                          checked={plan === 2 ? false : true}
                          style={{transform: "scale(1.5)",}}
                          name={1}
                          onChange={checkBoxHandle}
                        > 60U/{t("portalText.Day")}</Checkbox>

                        <Checkbox
                          className="checkbox"                 
                          checked={plan === 2 ? true : false}
                          style={{transform: "scale(1.5)",}}
                          name={2}
                          onChange={checkBoxHandle}
                        > 300U/{t("portalText.Week")} </Checkbox>

                      </div>                                         
                    </>                          
                  }
                    <PrimaryButton disabled={loader} name="subscribe" onClick={()=>setFlow("CONFIRM")} type="primary"
                      > {t("portalText.Subscribe")}
                      </PrimaryButton>             
                  <a onClick={() => setFlow("HE")} className="send_otp_link"> &lt;&lt;&nbsp;{t("portalText.Back")}</a><br/>
              </>
              ): 
              <>
                    <h2>{t("portalText.Welcome")}</h2>
                    {t("portalText.descWel")}
                    <p>{t("portalText.Enter Number")}</p>
                      <div className="phone-input">  
                        <div className="has-validation input-group">
                            <div className="dialing-code">
                                <img src={"https://flagcdn.com/"+flag+".svg"} width="24" alt="Cameroon" />
                                <span>+{countryCode}</span>
                            </div>
                           
                            <input                                    
                              className="form-control form-mobile-no" 
                              type="number" 
                              inputMode="numeric" 
                              value={number?number:''}
                              onChange={handleNumberChange}
                              placeholder={t("portalText.Enter Number")}
                            />             
                        </div>
                         <br/>
                       <div className="check_box_container">                   
                            <input type="checkbox" id="terms" name="Terms & Conditions" value="Terms"
                                className="check_box" onChange={()=>{}} checked/>
                            <label   className="check_box_label">
                                  {t("portalText.TNC1")}  <span className="terms_conditions" onClick={()=>setTermsModal(true)}>{t("portalText.TNC2")}</span>
                            </label> 
                        </div>        
                      </div> 
                    <PrimaryButton disabled={loader}  name="subscribe" onClick={sendOtp} type="primary"
                    >{t("portalText.login")}</PrimaryButton>
                    
                </>
              }
           </SubInfo>
          </InfoBox>
        </ContentContainer>
      </HomeContainer> 
      {loader && <Loader />}
       {termsModal && <TermsModal setTermsModal={setTermsModal} />} 
    </React.Fragment>
  );
};

export default Sub;



